var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdoo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.1 15.796a2.9 2.9 0 1 1 0-5.8a2.9 2.9 0 0 1 0 5.8m0-1.2a1.7 1.7 0 1 0 .002-3.4H21.1a1.7 1.7 0 0 0 0 3.4m-6.065 1.2a2.9 2.9 0 1 1 0-5.8a2.9 2.9 0 0 1 0 5.8m0-1.2a1.7 1.7 0 1 0 .002-3.4h-.002a1.7 1.7 0 0 0 0 3.4m-3.17-1.738c0 1.62-1.298 2.938-2.898 2.938s-2.9-1.314-2.9-2.936S7.248 10 8.968 10c.636 0 1.224.134 1.7.484v-1.68a.6.6 0 0 1 1.2 0v4.054zm-2.898 1.74a1.7 1.7 0 0 0 .002-3.4h-.002a1.7 1.7 0 0 0 0 3.4M2.9 15.796a2.9 2.9 0 1 1 0-5.8a2.9 2.9 0 0 1 0 5.8m0-1.2a1.7 1.7 0 1 0 .002-3.4H2.9a1.7 1.7 0 0 0 0 3.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdoo);
export default __webpack_public_path__ + "static/media/odoo.6938b15e531306c4c618884c643823e4.svg";
export { ForwardRef as ReactComponent };